import { render, staticRenderFns } from "./RequiredContact.vue?vue&type=template&id=7b673552&scoped=true&"
import script from "./RequiredContact.vue?vue&type=script&lang=ts&"
export * from "./RequiredContact.vue?vue&type=script&lang=ts&"
import style0 from "./RequiredContact.vue?vue&type=style&index=0&id=7b673552&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b673552",
  null
  
)

export default component.exports